import React, { Component } from "react"
import PropTypes from "prop-types"
import PostIcons from "../components/PostIcons"
import Img from "gatsby-image"
import Disqus from 'disqus-react';
import {Helmet} from "react-helmet";
import PostHeader from '../components/PostHeader';

class PostTemplate extends Component {
  render() {
    const post = this.props.data.contentfulBlogPost
    const disqusShortname = 'tonnguyen';
        const disqusConfig = {
            url: post.url,
            identifier: post.id,
            title: post.title,
        };
    const author = this.props.data.contentfulPerson

    return (
      <div className="single">
        <article className="post type-post status-publish format-standard hentry ">
          <Helmet encodeSpecialCharacters={false}>
              <meta charSet="utf-8" />
              <meta name="description" content={post.body.childMarkdownRemark.excerpt} />
              <title>{`${this.props.data.contentfulSiteSettings.title} - ${post.title}`}</title>
          </Helmet>
          <PostHeader {...{post, author}} />
          <div className="entry-content" dangerouslySetInnerHTML={{__html: post.body.childMarkdownRemark.html}}>
          </div>
          <div className="entry-footer">
          <PostIcons node={post} className="entry-footer" tag={true} title={true} date={false} />
            <Disqus.DiscussionEmbed shortname={disqusShortname} config={disqusConfig} />
          </div>
        </article>
      </div>
    )
  }
}

PostTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  edges: PropTypes.array,
}

export default PostTemplate

export const pageQuery = graphql`
  query currentPostQuery($id: String!) {
    contentfulBlogPost(id: { eq: $id }) {
      title
      body {
        childMarkdownRemark {
          html
          excerpt
        }
      }
      ...PostIcons
    }
    contentfulSiteSettings {
      title
    }
    contentfulPerson(id: {eq: "c15jwOBqpxqSAOy2eOO4S0m"}) {
      name
      image {
        resolutions(width: 24, height: 24) {
          ...GatsbyContentfulResolutions
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/post.js